module.exports = __webpack_public_path__ + "static/media/Danielle Harvey.0ec06541.png";